import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

/**
 * @param {object} root
 * @param {boolean} root.disabled
 * @param {Function} root.onClick
 * @param {string} root.value
 * @param {boolean} root.isModalOpen
 * @returns {React.ReactComponentElement} - TimeSpanButton component
 */
function TimeSpanButton({
  disabled, onClick, value, isModalOpen,
}) {
  const disabledStyle = { zIndex: 1, opacity: 0.65, cursor: 'not-allowed' };
  const isBtnDisabled = disabled || isModalOpen;
  const btnStyle = isBtnDisabled ? disabledStyle : {};
  return (
    <Button
      className="btn btn-darken"
      onClick={onClick}
      disabled={isBtnDisabled}
      autoFocus={false}
      style={btnStyle}
    >
      {value}
    </Button>
  );
}

TimeSpanButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  value: PropTypes.string,
  isModalOpen: PropTypes.bool,
};

TimeSpanButton.defaultProps = {
  disabled: false,
  onClick: null,
  value: <FormattedMessage id="dashboard.timespan_button.default_value.label" defaultMessage="loading..." />,
  isModalOpen: false,
};

export default TimeSpanButton;
